// Per-step-type RJSF uiSchema overrides. Adds placeholders, array widget hints,
// and minor layout tweaks to make the schema-rendered forms friendlier than the
// raw RJSF defaults. Returned uiSchema is merged at render time in <StepCard>.

type UiSchema = Record<string, unknown>;

const uiSchemasByType: Record<string, UiSchema> = {
  "filter.symbol_allowlist": {
    symbols: {
      "ui:options": { orderable: false },
      items: { "ui:placeholder": "EURUSD" },
    },
  },
  "filter.symbol_blocklist": {
    symbols: {
      "ui:options": { orderable: false },
      items: { "ui:placeholder": "EURUSD" },
    },
  },
  "filter.action_allowlist": {
    actions: {
      "ui:options": { orderable: false },
      items: { "ui:placeholder": "buy" },
    },
  },
  "filter.time_window": {
    tz: { "ui:placeholder": "UTC" },
    windows: {
      "ui:options": { orderable: false },
      items: {
        from: { "ui:placeholder": "09:00" },
        to: { "ui:placeholder": "17:00" },
      },
    },
  },
  "transform.symbol_map": {
    map: {
      "ui:options": { orderable: false },
      additionalProperties: { "ui:placeholder": "BROKER_SYMBOL" },
    },
  },
  "transform.volume_scaler": {
    factor: { "ui:placeholder": "1.0" },
  },
  "transform.comment_template": {
    template: {
      "ui:placeholder": "Signalync: {action} {symbol} @ {volume}",
    },
  },
};

export function uiSchemaFor(stepType: string): UiSchema {
  return uiSchemasByType[stepType] ?? {};
}
